// extracted by mini-css-extract-plugin
export default {"wrapper":"jA-z","addressLine":"kA-z","fullName":"lA-z"};